import { createSelector } from '@reduxjs/toolkit';
import { getOrganization } from '../organization/getOrganization';
import type { FunctionViewModel } from '@trinnvis/dabih-api-client';

import { toList } from '../toList';

export const functionsWithTaskCount = createSelector(getOrganization, (m) => {
  if (m === undefined) {
    return [];
  }
  const withTaskCount = function (e: FunctionViewModel): FunctionViewModel & { taskCount: number } {
    return Object.assign({}, e, {
      taskCount: toList(m.tasksById)
        .filter(function (c) {
          return !c.deleted;
        })
        .filter(function (c) {
          return c.functionUuid === e.uuid || c.responsibleFunctionUuid === e.uuid;
        }).length,
    });
  };

  return toList(m.functionsById).map(withTaskCount);
});
